// **Persona Giuridica - Cliente Fields**
export const personaGiuridicaClienteFields = [
  {
    name: "ragioneSociale",
    label: "Ragione sociale",
    type: "text",
    required: true,
  },
  { name: "piva", label: "PIVA", type: "text", required: true },
  { name: "pec", label: "PEC", type: "text", required: false },
  { name: "codiceAteco", label: "Codice ATECO", type: "text", required: false },
  {
    name: "descrizioneAteco",
    label: "Descrizione ATECO",
    type: "text",
    required: false,
  },
  { name: "dipendenti", label: "Dipendenti", type: "text", required: false },
  {
    name: "dataDipendenti",
    label: "Data Dipendenti",
    type: "text",
    required: false,
  },
  {
    name: "dataFondazione",
    label: "Data Fondazione",
    type: "date",
    required: false,
  },
  { name: "codiceRea", label: "Codice REA", type: "text", required: false },
  {
    name: "slResProvincia",
    label: "Provincia",
    type: "select",
    required: true,
  },
  {
    name: "slResComuneCodice",
    label: "Comune",
    type: "select",
    required: true,
  },
  { name: "slResCap", label: "CAP", type: "select", required: true },
  {
    name: "slResIndirizzoVia",
    label: "Via",
    type: "select",
    optionsKey: "Via",
    required: true,
  },
  {
    name: "slResIndirizzo",
    label: "Indirizzo",
    type: "text",
    required: true,
  },
  { name: "slResCivico", label: "Civico", type: "text", required: true },
];

// **Persona Giuridica - Legale Fields**
export const personaGiuridicaLegaleFields = [
  { name: "cognome", label: "Cognome", type: "text", required: true },
  { name: "nome", label: "Nome", type: "text", required: true },
  { name: "cf", label: "Codice fiscale", type: "text", required: true },
  {
    name: "nascitaNazione",
    label: "Nazione nascita",
    type: "select",
    required: true,
  },
  {
    name: "nascitaProvincia",
    label: "Provincia nascita",
    type: "select",
    required: true,
  },
  {
    name: "nascitaComuneCodice",
    label: "Comune nascita",
    type: "select",
    required: true,
  },
  { name: "dataNascita", label: "Data nascita", type: "date", required: true },
  {
    name: "slResProvincia",
    label: "Provincia",
    type: "select",
    required: true,
  },
  {
    name: "slResComuneCodice",
    label: "Comune",
    type: "select",
    required: true,
  },
  { name: "slResCap", label: "CAP", type: "select", required: true },
  {
    name: "slResIndirizzoVia",
    label: "Via",
    type: "select",
    optionsKey: "VIA",
    required: true,
  },
  {
    name: "slResIndirizzo",
    label: "Indirizzo",
    type: "text",
    required: true,
  },
  { name: "slResCivico", label: "Civico", type: "text", required: true },
];

// **Persona Fisica - Cliente Fields**
export const personaFisicaClienteFields = [
  { name: "cognome", label: "Cognome", type: "text", required: true },
  { name: "nome", label: "Nome", type: "text", required: true },
  { name: "cf", label: "Codice fiscale", type: "text", required: true },
  {
    name: "nascitaNazione",
    label: "Nazione nascita",
    type: "select",
    required: true,
  },
  {
    name: "nascitaProvincia",
    label: "Provincia nascita",
    type: "select",
    required: true,
  },
  {
    name: "nascitaComuneCodice",
    label: "Comune nascita",
    type: "select",
    required: true,
  },
  { name: "dataNascita", label: "Data nascita", type: "date", required: true },
  {
    name: "slResProvincia",
    label: "Provincia",
    type: "select",
    required: true,
  },
  {
    name: "slResComuneCodice",
    label: "Comune",
    type: "select",
    required: true,
  },
  { name: "slResCap", label: "CAP", type: "select", required: true },
  {
    name: "slResIndirizzoVia",
    label: "Via",
    type: "select",
    optionsKey: "Via",
    required: true,
  },
  {
    name: "slResIndirizzo",
    label: "Indirizzo",
    type: "text",
    required: true,
  },
  { name: "slResCivico", label: "Civico", type: "text", required: true },
];

// **Veicolo fields**
export const veicoloFields = [
  {
    name: "targa",
    label: "Targa",
    type: "text",
    required: true,
    disabled: true,
  },
  {
    name: "tipoVeicolo",
    label: "Tipo Veicolo",
    type: "select",
    required: true,
  },
  { name: "telaio", label: "Telaio", type: "text", required: true },
  { name: "marca", label: "Marca", type: "text", required: true },
  { name: "modello", label: "Modello", type: "text", required: true },
  {
    name: "allestimento",
    label: "Allestimento",
    type: "text",
    required: false,
  },
  {
    name: "Data_Immatricolazione",
    label: "Data Immatricolazione",
    type: "date",
    required: true,
  },
  {
    name: "dataAcquisto",
    label: "Data Acquisto",
    type: "date",
    required: true,
  },
  { name: "uso", label: "Uso", type: "select", required: true },
  { name: "cilindrata", label: "Cilindrata", type: "text", required: true },
  {
    name: "cavalliFiscali",
    label: "Cavalli Fiscali",
    type: "text",
    required: true,
  },
  { name: "KW", label: "KW", type: "text", required: true },
  {
    name: "massaComplessiva",
    label: "Massa Complessiva",
    type: "text",
    required: false,
  },
  {
    name: "massaRimorchio",
    label: "Massa Rimorchio",
    type: "text",
    required: false,
  },
  {
    name: "alimentazione",
    label: "Alimentazione",
    type: "select",
    required: true,
  },
  {
    name: "assicurazioneProvenienza",
    label: "Assicurazione Provenienza",
    type: "text",
    required: true,
  },
  {
    name: "classeMerito",
    label: "Classe Merito",
    type: "text",
    required: true,
  },
  { name: "tariffa", label: "Tariffa", type: "select", required: true },
  {
    name: "dataInizioCopertura",
    label: "Inizio Copertura",
    type: "date",
    required: true,
  },
  {
    name: "dataFineCopertura",
    label: "Fine Copertura",
    type: "date",
    required: true,
  },
  { name: "dataMora", label: "Data Mora", type: "date", required: true },
];
